import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import { Toast } from 'dibs-toaster/exports/Toast';

import {
    getPersonalizedFilterValues,
    shouldApplyPersonalizedFilter,
} from '../../shared/helpers/personalizedFiltersHelpers';
import { QP_PERSONALIZED_FILTER_VALUE_SHIPPING_FREE } from '../../constants/queryParamConstants';

import styles from './SbSharedPersonalizedFilterToast.scss';

const toastMessages = {
    [QP_PERSONALIZED_FILTER_VALUE_SHIPPING_FREE]: {
        header: (
            <FormattedMessage
                id="sb.SbSharedPersonalizedFilterToast.shippingFree.header"
                defaultMessage="Sorry, No Free Shipping"
            />
        ),
        text: (
            <FormattedMessage
                id="sb.SbSharedPersonalizedFilterToast.shippingFree.text"
                defaultMessage="Items on this page don’t ship free to you. Try another postal code in the Shipping Options filter below or search local items that may have favorable shipping options."
            />
        ),
    },
};

const SbSharedPersonalizedFilterToastComponent = ({ shippingFilters }) => {
    const [personalizedFilterValues, setPersonalizedFilterValues] = useState([]);

    useEffect(() => {
        setPersonalizedFilterValues(getPersonalizedFilterValues() || []);
    }, []);

    if (shippingFilters && personalizedFilterValues.length) {
        const personalizedFilterValue = personalizedFilterValues[0];
        const toastMessage = toastMessages[personalizedFilterValue];

        if (
            toastMessage &&
            !shouldApplyPersonalizedFilter({ personalizedFilterValue, shippingFilters })
        ) {
            return (
                <Toast position="topLeft">
                    <div className={styles.header}>{toastMessage.header}</div>
                    {toastMessage.text}
                </Toast>
            );
        }
    }

    return null;
};

SbSharedPersonalizedFilterToastComponent.propTypes = {
    shippingFilters: PropTypes.array,
};

export const SbSharedPersonalizedFilterToast = createFragmentContainer(
    SbSharedPersonalizedFilterToastComponent,
    {
        shippingFilters: graphql`
            fragment SbSharedPersonalizedFilterToast_shippingFilters on ShippingFilterType
                @relay(plural: true) {
                ...personalizedFiltersHelpers_shippingFilters @relay(mask: false)
            }
        `,
    }
);
